import React from "react";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  brands: server.dto.Brand[]
}

const LogoOrButton = (props: { brand: server.dto.Brand }) => (
  <div className="brand-info-panel-logo">
    {props.brand.logoUrl &&
      <a href={routes.brand_Edit(props.brand.brandId).absolute}>
        <img src={props.brand.logoUrl} title={props.brand.name} />
      </a>}
    {!props.brand.logoUrl &&
      <a href={routes.brand_Edit(props.brand.brandId).absolute} className="button-new tertiary fluid">{RESX.Branding.ProvideYourCompanyLogo}</a>}
  </div >);

const BrandCard = (props: { brand: server.dto.Brand }) => {
  const { brand } = props;

  return <div className="s1_panel">

    <div className="content-section flex-column gap-big">

      <LogoOrButton brand={brand} />

      <div className="brand-info-panel-details">
        <div className="brand-info-panel-details-company">
          <h3 className="info-text-semibold">{brand.name}</h3>
          <div className="label-text-regular">{RESX.Branding.Handle}: {props.brand.friendlyId}</div>
        </div>
        <a className="brand-info-panel-change-link subtitle-text-medium" href={routes.brand_Edit(brand.brandId).absolute}>{RESX.Buttons.Change}</a>
      </div>
    </div>
  </div>;
};

const BrandsInfoPanel = (props: Props) => (<>
  {
    props.brands.map((brand) => <BrandCard key={brand.brandId} brand={brand} />)
  }
</>);

export default BrandsInfoPanel;
